import { FC, ReactNode } from 'react';

import { useConfigContext } from '../../context/ConfigContext';
import Footer from '../footer/Footer';
import Header from '../header/Header';

export type GenericLayoutProps = {
  children?: ReactNode;
  title: string;
};

const GenericLayout: FC<GenericLayoutProps> = ({ children, title }) => {
  const { company } = useConfigContext();

  document.title = `${title} - ${company.name}`;

  return (
    <>
      <Header />
      {children && <article>{children}</article>}
      <Footer />
    </>
  );
};

export default GenericLayout;
